import type { WiseEnvironment } from "@1js/wise-environments";
import type { AdaptiveLogger } from "@1js/office-online-jsapi-core";
import type { IWACPageLoadResult } from "../../messages/messageTypes/Notification";
import type {
  BootFailedError,
  DocumentBootInfo,
  EventHandlers,
  SessionConfig,
  UiHostConfig,
} from "../../types";
import { updateLoggerDataBoundaryUsingRegion } from "../../frame/updateLoggerWithDataBoundary";
import type { Health } from "@1js/office-online-qos-small";

export async function pageLoadedHandler(
  hostGeoRegion: string = "",
  wiseEnvironment: WiseEnvironment,
  pageLoadResult: IWACPageLoadResult,
  docBootInfo: DocumentBootInfo,
  uiHostEventHandlers: EventHandlers,
  logger?: AdaptiveLogger,
  sessionConfig?: SessionConfig,
  uiHostConfig?: UiHostConfig,
  health?: Health,
  sessionId?: string
) {
  updateLoggerDataBoundaryUsingRegion(
    hostGeoRegion,
    wiseEnvironment,
    logger,
    health,
    sessionId,
    docBootInfo,
    sessionConfig,
    uiHostConfig
  );
  if (pageLoadResult.resultType === "Success") {
    uiHostEventHandlers.onBootComplete?.(docBootInfo);
  } else {
    const errorInfo: BootFailedError = {
      errorMessage: pageLoadResult.errorInfo || "",
      errorName: pageLoadResult.resultCode || "",
    };
    uiHostEventHandlers.onBootFailure?.(errorInfo, docBootInfo);
  }
}
